import ApiCore from './api-core'
import { PUBLIC } from '@/constants/api-types'

export default class Setting extends ApiCore {
  constructor(store) {
    super(store, `${PUBLIC}/setting`)
  }

  get(showProgress) {
    return this.request({
      method: 'GET',
      showProgress
    })
  }
}
